import React from 'react'

export default () => (
  <img src="/404.jpg" style={{marginLeft: 'auto', marginRight: 'auto', padding: '24px', display: 'block'}}/>
)